import { Injectable } from '@angular/core';
import {UserService} from "./user.service";
import {Observable} from "rxjs/Observable";

@Injectable()
export class SecuirtyService {

  constructor(private userService: UserService) { }
    // generatSecretId
    public generateKey(keyObj): Observable<any>{
        return this.userService.request('post', 'generateKey',keyObj)
    }
    // getGenerateKey
    public getGenerateKey(): Observable<any>{
        return this.userService.request('get', 'getGenerateKey')
    }
    public updategenerateKey(keyObj): Observable<any>{
        return this.userService.request('post', 'updategenerateapikey',keyObj)
    }
    public deleteAPIKey(keyid): Observable<any>{
        return this.userService.request('get', 'deleteapikey',null,{keyid:keyid})
    }
}



// WEBPACK FOOTER //
// ./src/app/services/secuirty.service.ts